import { Component, OnInit } from '@angular/core';
import { HttpModule } from '@angular/http';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { FlashMessagesService } from 'angular2-flash-messages';

// Services
import { TypeOfIndebtednessEditService } from '../../service/type-of-indebtedness-edit/type-of-indebtedness-edit.service';

@Component({
	selector: 'app-type-of-indebtedness-edit',
	templateUrl: './type-of-indebtedness-edit.component.html',
	providers: [
		TypeOfIndebtednessEditService,
		HttpModule
	]
})
export class TypeOfIndebtednessEditComponent implements OnInit {
	indebtedness: FormGroup;
	ID: string;
	Tipo: string;
	Ativo: boolean;
	private token;
	private sub: any;
	public permissoes: any[] = [];

	constructor(fb: FormBuilder, private typeOfIndebtednessEditService: TypeOfIndebtednessEditService, private flashMessagesService: FlashMessagesService, private router: Router, private route: ActivatedRoute) {
		this.token = localStorage.getItem('yara.token');
		this.indebtedness = fb.group({
			'ID': '',
			'Tipo': ['', Validators.compose([Validators.required, Validators.maxLength(120)])],
			'Ativo': ''
		});
	}

	ngOnInit() {
		this.permissoes = localStorage.getItem('yara.permissions') ? JSON.parse(localStorage.getItem('yara.permissions')) : [];
		this.sub = this.route.params.subscribe(params => {
			this.ID = params['guid'];
			this.typeOfIndebtednessEditService.loadIndebtedness(this.token, this.ID).subscribe(result => {
				var updateIndebtedness = result.Result;
				this.indebtedness.setValue({
					ID: updateIndebtedness.ID,
					Tipo: updateIndebtedness.Tipo,
					Ativo: updateIndebtedness.Ativo
				});
			})
		}, error => {
			console.log(error);
			
		});
	}

	editIndebtedness(value: any) {
		this.typeOfIndebtednessEditService.editIndebtedness(this.token, value).subscribe(result => {
			if (result.Success) {
				this.flashMessagesService.show("Tipo de Endividamento editado com sucesso", { cssClass: 'alert-success', timeout: 6000 });
				this.router.navigateByUrl('/tipo-endividamento');
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
			
		});
	}

	cancelInsertEdit() {
		this.router.navigateByUrl('/tipo-endividamento');
	}

}




// WEBPACK FOOTER //
// ./src/app/type-of-indebtedness/component/type-of-indebtedness-edit/type-of-indebtedness-edit.component.ts